<template>
  <div class="about-bg">
    <!-- Employee Area Starts -->
    <section class="employee-area section-padding zoomIn animated">
      <div class="container row-li">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center ">
              <h2>宜昌艾福斯</h2>
              <!-- <p>Open lesser winged midst wherein may morning</p> -->
              <ul class="mt-4 section-content" v-for="(v, i) in aboutList" :key="i">
                <li class="mb-3">{{ v.content }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Employee Area End -->
  </div>
</template>

<script>
export default {

  name: 'about',
  data () {
    return {
      aboutList: [
        {
          content: '宜昌市艾福斯信息咨询有限责任公司成立于2003年10月24日，作为获得CMMI认证的高新技术软件企业，专业从事数字化管理软件开发、能源电力行业应用软件产品研制和销售、管理软件咨询、技术服务以及信息技术软硬件产品进出口业务。'
        },
        {
          content: '宜昌市艾福斯信息咨询有限责任公司管理架构包括市场拓展部、应用咨询部、技术开发部、综合行政部，拥有10多名在能源电力行业和相关信息技术领域有着15年以上产品研究、开发和咨询服务的高级业务顾问和高级程序顾问。'
        },
        {
          content: '宜昌市艾福斯信息咨询有限责任公司是IFS软件在水电行业和中国区本地化的实施和技术开发战略合作伙伴，同时也是帆软企业商业智能软件和报表工具的实施合作伙伴。公司立足于先进的ERP软件、国产自主可控数据库、开源软件技术和研发工具，始终以“满足用户需求”为服务宗旨，致力于为资产密集型及项目管理型企业设计开发数字化全面解决方案，解决方案吸纳了国外大型ERP软件的管理思想和结合了中国企业的管理特点，包括完整的应用软件程序系统、业务流程标准库、信息资源管理基础标准库、报表库和配套的系统实施开发方法。经过20多年的技术研发积累和项目实施开发经验打磨，公司的核心技术与服务团队不仅具有丰富的能源电力行业管理数字化和信息技术专业知识，而且具备与国际接轨的大型软件项目实施开发的项目管理经验。'
        }
        // {
        //   content: '公司经过多年的技术研发积累和项目实施开发经验打磨，公司的核心技术与服务团队不仅具有丰富的资产密集型行业管理数字化经验和信息技术专业知识，而且基本都具备大型软件项目实施开发的项目管理经验、以及与国际接轨的大型软件开发标准与实践经验。'
        // },
        // {
        //   content: '公司是IFS软件产品在水电行业和中国区本地化的实施和技术开发战略合作伙伴，同时也是ORACLE公司全套数据库、数据仓库、企业商业智能软件的OPN产品代理与实施合作伙伴。'
        // }
      ]
    }
  }
}
</script>

<style scoped>
.row-li {
  color: black
}

.about-bg {
  background: url(../../static/assets/images/about-bg.jpg) no-repeat;
  background-size: 100% 100%;
}
.section-content{
  line-height: 2.4;
}
</style>




// WEBPACK FOOTER //
// About.vue?3800007a